// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__3_fnK","row":"style_row__1wSV6","title":"style_title__3t_B9","outlined":"style_outlined__1A_Rp"};